"use strict";

exports.__esModule = true;
exports.createClock = createClock;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Clock = /*#__PURE__*/function () {
  function Clock(interval) {
    if (interval === void 0) {
      interval = 10;
    }
    this.subscribers = new Set();
    this._timerID = null;
    this.interval = interval;
  }
  var _proto = Clock.prototype;
  _proto.subscribe = function subscribe(callback) {
    var _this = this;
    this.subscribers.add(callback);
    if (this._timerID == null) {
      this._timerID = setTimeout(tick, this.interval, this);
    }
    return function () {
      _this.subscribers["delete"](callback);
      if (_this.subscribers.size === 0 && _this._timerID != null) {
        clearTimeout(_this._timerID);
        _this._timerID = null;
      }
    };
  };
  return Clock;
}();
function tick(clock) {
  try {
    var now = new Date();
    for (var _iterator = _createForOfIteratorHelperLoose(clock.subscribers), _step; !(_step = _iterator()).done;) {
      var subscriber = _step.value;
      subscriber(now);
    }
  } finally {
    clock._timerID = setTimeout(tick, clock.interval, clock);
  }
}

/**
 * Create a clock which runs at the specified interval between ticks.
 */
function createClock(interval) {
  if (interval === void 0) {
    interval = 10;
  }
  return new Clock(interval);
}